module.exports = __webpack_public_path__ + "static/media/moveHouse.58d04d49.jpg";